const development_tenant = {
    notification: 'Bạn đang ở chế độ phát triển',
};
export default Object.freeze(development_tenant);
